import React from 'react'

import Header from './sections/Header'
import Page from '../../../../components/pdf/Page'

import CoverSection from './sections/00.CoverSection'
import RevisionsSection from './sections/00.RevisionsSection'
import IndexSection from './sections/00.IndexSection'
import CompanyInfoSection from './sections/01.CompanyInfoSection'
import IntroSection from './sections/02.IntroSection'
import StructureSection from './sections/03.StructureSection'
import RiskInventorySection from './sections/04.RiskInventorySection'
import SchedulingSection from './sections/05.SchedulingSection'
import FinalConsiderationsSection from './sections/06.FinalConsiderationsSection'
import SignatureSection from './sections/07.SignatureSection'
import AttachmentsSection from './sections/08.AttachmentsSection'

const PdfDocument = ({ serviceOrder, certify }) => {
  return (
    <Page header={<Header />}>
      <CoverSection serviceOrder={serviceOrder} />
      <RevisionsSection serviceOrder={serviceOrder} />
      <IndexSection serviceOrder={serviceOrder} />
      <CompanyInfoSection serviceOrder={serviceOrder} />
      <IntroSection />
      <StructureSection />
      <RiskInventorySection serviceOrder={serviceOrder} />
      <SchedulingSection serviceOrder={serviceOrder} />
      <FinalConsiderationsSection />
      <SignatureSection />
      <AttachmentsSection certify={certify} />
    </Page>
  )
}

export default PdfDocument
